module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CheckoutFreeDelivery":{"progress":{"text":"Nakupte ještě za {price} {textBold}","textBold":"a dopravu máte zdarma"},"active":"Doprava zdarma!"}}}')
  delete Component.options._Ctor
}
